import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} className={cn('bg-gold-500 hover:bg-gold-400 text-white font-display text-xl md:text-2xl px-8 py-4 rounded-full shadow-[0_0_20px_rgba(255,122,24,0.35)] hover:shadow-[0_0_30px_rgba(255,122,24,0.6)] transition-all duration-300 flex items-center justify-center gap-2 w-full max-w-xl mx-auto', className)} {...props} data-id="element-205">
      {children}
    </motion.button>;
}